(function(){
  var el = document.getElementById('cd');
  if (!el) return;
  var t = 2 * 3600, id = setInterval(tick, 1000);
  function p(n){ return n < 10 ? '0' + n : '' + n; }
  function tick(){
    var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
    el.textContent = p(h) + ':' + p(m) + ':' + p(s);
    if (t > 0) { t--; } else { clearInterval(id); el.textContent = 'Ending soon'; }
  }
  tick();

  // fade the comparison scroller's right edge only while there is more to see
  var sc = document.querySelector('.cmpscroll');
  if (sc) {
    var hint = document.querySelector('.swipe');
    var mark = function(){
      var scrollable = sc.scrollWidth > sc.clientWidth + 1;
      sc.classList.toggle('at-end', !scrollable || sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2);
      if (hint) hint.classList.toggle('on', scrollable);
    };
    sc.addEventListener('scroll', mark, { passive: true });
    addEventListener('resize', mark);
    mark();
  }
})();